import React from "react";
import { useLocation } from "react-router-dom";
import { LayoutHeader2 } from "../components/Interactions/LayoutHeader2";
import Stages from "../components/Pipelines/Pipeline";

export const Pipeline: React.FC = () => {
  const { state } = useLocation() as { state?: { pipelineId?: number } };

  return (
    <LayoutHeader2>
      <Stages />
    </LayoutHeader2>
  );
};
